import axios from "axios";

/**
 * =====================================================
 * CONFIG
 * =====================================================
 */

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://api.laesquinadelparques.com/api";

/**
 * =====================================================
 * TOKEN
 * =====================================================
 */

const getAuthToken = () => {
  try {
    const auth = localStorage.getItem("auth");
    if (!auth) return null;

    const parsed = JSON.parse(auth);
    return parsed?.access || null;
  } catch (err) {
    console.error("Token parse error:", err);
    return null;
  }
};

/**
 * =====================================================
 * AXIOS INSTANCE
 * =====================================================
 */

const API = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false, // 🔥 JWT NO necesita cookies normalmente
});

/**
 * =====================================================
 * REQUEST INTERCEPTOR (ATTACH TOKEN)
 * =====================================================
 */

API.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * =====================================================
 * RESPONSE INTERCEPTOR (AUTO LOGOUT)
 * =====================================================
 */

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      localStorage.removeItem("auth");
      localStorage.removeItem("access");
      localStorage.removeItem("refresh");
    }

    return Promise.reject(error);
  }
);

export default API;